<template>
  <ion-app>
    <ion-router-outlet v-if="appData && sharedState.ui" />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet, isPlatform, modalController } from '@ionic/vue';
import DownloadModal from '@/components/DownloadModal.vue';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { defineComponent } from 'vue';
import { store } from '@/store';
import { storage } from '@/storage';
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
  },
  data() {
    return {
      appData: null,
      acronyms: null,
      storage: storage,
      sharedState: store.state,
      lang: null,
      firebaseConfig: {
        apiKey: "AIzaSyDoeD1KF3RyZomQZjxYbgNZ2a0JO4skav8",
        authDomain: "namisd-alfredu.firebaseapp.com",
        projectId: "namisd-alfredu",
        storageBucket: "namisd-alfredu.firebasestorage.app",
        messagingSenderId: "310019206365",
        appId: "1:310019206365:web:c268256a28911feb1cbf34",
        measurementId: "G-ZMFJZ3D1HP"
      }
    }
  },
  methods: {
    getAppData: async function() {
      return this.appData = await store.getAppData();
    },
    updateUiData: async function() {
      this.lang = await store.getLanguage();
      await store.updateUiData(this.lang);
      document.documentElement.setAttribute('lang', this.lang);
    },
    updateDeviceInfo: async function() {
      let os = store.getItem('deviceType');
      if(isPlatform('ios')) os = 'ios';
      if(isPlatform('android')) os = 'android';
      await store.updateItem('deviceType', os);
    },
    checkNetworkStatus: async function() {
      const status = await Network.getStatus();
      await store.updateItem('networkAvailable', status.connected);
      await this.updateDataPrefix();
    },
    updateDataPrefix: async function() {
       // Set to use local data source
      let dataPrefix = '';
      const prodUrl = 'https://app.alfredu.org';
      // const stageUrl = 'https://app-staging.alfredu.org';
      const stageUrl = 'https://dev.alfredu.org';
      // If network is avan_deigailable we will use remote data sources
      if (await this.sharedState.networkAvailable) {
        dataPrefix = prodUrl;
        if (window.location?.origin?.includes(stageUrl) === true) {
          dataPrefix = stageUrl;
        }
        if (!Capacitor.isNativePlatform() && window.location?.origin?.includes('localhost') === true) {
          dataPrefix = stageUrl;
        }
      }
      await store.updateItem('dataPrefix', dataPrefix);
    },
    updateCategoryData: async function() {
      const lang = this.lang || await store.getLanguage();
      await store.updateCategoryData(lang);
    },
    initGA: async function() {
      if (Capacitor.isNativePlatform()) {
        // Native platforms use Capacitor plugin
        try {
          await FirebaseAnalytics.initializeFirebase(this.firebaseConfig);
          await FirebaseAnalytics.logEvent({ name: "init_app" });
        } catch (error) {
          console.warn('Firebase Analytics initialization failed:', error);
        }
      } else {
        // Web platform uses Firebase web SDK
        try {
          const app = initializeApp(this.firebaseConfig);
          const analytics = getAnalytics(app);
          logEvent(analytics, 'init_app');
        } catch (error) {
          console.warn('Firebase Analytics web initialization failed:', error);
        }
      }
    }
  },
  watch: {
    'sharedState.language': async function() {
      await this.updateUiData();
      await store.updateAppData();
      await this.getAppData();
      await this.updateCategoryData();
    },
    'sharedState.networkAvailable': async function() {
      await this.updateDataPrefix();
    }
     
  },
  async beforeMount() {
    await this.checkNetworkStatus();
    await this.updateDeviceInfo();
    await this.getAppData();
    await this.updateUiData();
    await this.updateCategoryData();
    await this.initGA();
  },
  async mounted() {
    if (isPlatform('mobileweb')) {
      const modal = await modalController.create({ component: DownloadModal, cssClass: 'download-modal' });
      setTimeout(async () => {
        await modal.present();
      }, 500);
    }
  }
});
</script>